import React, { Fragment } from 'react'
import { UserIcon, Loader } from '../../application'
import { InviteUser } from './components'
import getText from '../strings'

export default ({ onChange, loading, onBlur, ...user }) => {
  return (
    <InviteUser>
      {loading
        ? <Loader />
        : <Fragment>
          <UserIcon {...user} />
          <div>
            <h4>{user.firstName}</h4>
          </div>
          <input
            className='formControl'
            id={`passengerIndex_${user.index}`}
            type='text'
            defaultValue={user.invitationEmail}
            placeholder={getText('manage', 'email')}
            onChange={(e) => onChange(user.index, e.target.value)}
            onBlur={onBlur}
          />
        </Fragment>
      }
    </InviteUser>
  )
}